<template>
  <div class="t-review">
    <TAvatar
      :img-prop="imgProp"
      size="md"
      variant="image"
      :title="authorName"
      :subtitle="toRuralityDate().displayDate(createdAt)"
      class="mb-1"
    />

    <TStarsGoogle class="mb-2" :stars="rating" />

    <TText classes="mb-2" clamp="clamp3">
      {{ removeCarriageReturns(text) }}
    </TText>
    <div class="flex items-center">
      <TText color="text-gray-600" clamp="clamp1" classes="mb-0 mr-2">
        {{ t('views.cottage.googleReviews') }}
      </TText>
      <UIcon name="i-logos-google" aria-hidden="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TLazyimg_Props } from '~~/modules/design-system/components/t-lazyimg/constants/types'
import removeCarriageReturns from '~/utils/removeCarriageReturns'

export interface Props {
  authorName: string
  createdAt: string
  profilePhotoUrl: string
  rating: number
  text: string
}

const props = withDefaults(defineProps<Props>(), {
  authorName: '',
  profilePhotoUrl: '',
  rating: 0,
  text: '',
  createdAt: '',
})

const imgProp: TLazyimg_Props = {
  src: props.profilePhotoUrl as string,
  alt: props.authorName,
}
</script>
